var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "product-carousel__image-wrapper",
      class: { "product-carousel__image-wrapper--video": _vm.hasVideo },
      on: { click: _vm.playVideo },
    },
    [
      _vm.hasVideo
        ? _c("icon", {
            staticClass: "product-carousel__play",
            attrs: {
              name: "play",
              size: _vm.$mq === "mobile" ? "50px" : "120px",
            },
          })
        : _vm._e(),
      _vm.showLabSeal
        ? _c("img", {
            staticClass: "product-carousel__lab-seal",
            attrs: { src: _vm.consumerLabSeal },
          })
        : _vm._e(),
      _c("img", {
        staticClass: "product-carousel__image",
        attrs: {
          src: _vm.normalizedImage.src,
          alt: _vm.imageAlt,
          draggable: "false",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }